// extracted by mini-css-extract-plugin
export default {"container":"style_container__WUnAX","column":"style_column__XcoRA","legends":"style_legends__4NQte","flipped":"style_flipped__qCi+2","middle":"style_middle__+gr0O"};